import { persistor } from 'src/store';

export const clearPersistor = () => {
  persistor.purge();
};
